"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reservationColumns = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Icon_1 = require("../../Icon");
const idColumn_1 = require("../../Table/columns/idColumn");
const selectColumn_1 = require("../../Table/columns/selectColumn");
const Tooltip_1 = require("../../Tooltip");
const actionsColumn_1 = require("./actionsColumn");
const CreatedAtCell_1 = require("./components/CreatedAtCell");
const FlightPassengersCell_1 = require("./components/FlightPassengersCell");
const ReservationPhoneCell_1 = require("./components/ReservationPhoneCell");
const ReservationStatusCell_1 = require("./components/ReservationStatusCell");
const ReservatorCell_1 = require("./components/ReservatorCell");
const Payment_1 = require("./Payment");
const reservationColumns = (config) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return [
        (0, selectColumn_1.selectColumn)({
            hidden: (_a = config.select) === null || _a === void 0 ? void 0 : _a.hidden,
        }),
        (0, idColumn_1.idColumn)({
            hidden: (_b = config.id) === null || _b === void 0 ? void 0 : _b.hidden,
        }),
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnOutbound', defaultMessage: 'Outbound' })),
            id: 'flightOutbound',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(FlightPassengersCell_1.FlightPassengersCell, { reservation: row.original, flight: row.original.flights.outbound })),
            hidden: (_c = config.outbound) === null || _c === void 0 ? void 0 : _c.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnReturn', defaultMessage: 'Return' })),
            id: 'flightReturn',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(FlightPassengersCell_1.FlightPassengersCell, { reservation: row.original, flight: row.original.flights.return })),
            hidden: (_d = config.return) === null || _d === void 0 ? void 0 : _d.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnStatus', defaultMessage: 'Status' })),
            id: 'reservationStatus',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(ReservationStatusCell_1.ReservationStatusCell, { value: row.original.status })),
            hidden: (_e = config.status) === null || _e === void 0 ? void 0 : _e.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnPayment', defaultMessage: 'Payment' })),
            id: 'payment',
            Cell: ({ row }) => {
                var _a, _b, _c;
                return (react_1.default.createElement(Payment_1.ListPaymentCell, { total: (_a = row.original.invoice) === null || _a === void 0 ? void 0 : _a.total, totalPaid: (_b = row.original.invoice) === null || _b === void 0 ? void 0 : _b.totalPaid, payments: (_c = row.original.invoice) === null || _c === void 0 ? void 0 : _c.payments }));
            },
            disableSortBy: true,
            hidden: (_f = config.payment) === null || _f === void 0 ? void 0 : _f.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnCreated', defaultMessage: 'Created' })),
            id: 'createdAt',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(CreatedAtCell_1.CreatedAtCell, { value: row.original.createdAt })),
            hidden: (_g = config.created) === null || _g === void 0 ? void 0 : _g.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnOwner', defaultMessage: 'Owner' })),
            id: 'customer',
            canSort: true,
            Cell: ({ row }) => {
                const { owner } = row.original;
                if (!owner)
                    return null;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement(ReservatorCell_1.ReservatorCell, { value: owner }),
                    react_1.default.createElement(ReservationPhoneCell_1.ReservationPhoneCell, { value: owner })));
            },
            hidden: (_h = config.owner) === null || _h === void 0 ? void 0 : _h.hidden,
        },
        {
            Header: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/List:ColumnReservator', defaultMessage: 'Reservator' })),
            id: 'reservator',
            canSort: true,
            Cell: ({ row }) => (react_1.default.createElement(ReservatorCell_1.ReservatorCell, { value: row.original.reservator })),
            hidden: (_j = config.reservator) === null || _j === void 0 ? void 0 : _j.hidden,
        },
        {
            Header: '',
            id: 'comment',
            canSort: false,
            Cell: ({ row }) => {
                const { comment } = row.original;
                return comment
                    ? (react_1.default.createElement(Tooltip_1.Tooltip, { modificators: ['white', 'left-aligned'], text: comment },
                        react_1.default.createElement(Icon_1.Icon, { name: 'speech-bubble' })))
                    : null;
            },
            headerClasses: ['table__selection'],
            hidden: (_k = config.comment) === null || _k === void 0 ? void 0 : _k.hidden,
        },
        (0, actionsColumn_1.reservationActionsColumn)(config.actions),
    ];
};
exports.reservationColumns = reservationColumns;
//# sourceMappingURL=tableColumns.js.map